import type { MisconceptionDefinition } from '../types';
export const GET_KOMMA: MisconceptionDefinition[] = [{
  id: 'get.decimal-align',
  label: 'Komma niet uitgelijnd',
  module: 'Getalbegrip',
  description: 'Leerling lijnt kommagetallen niet uit bij optellen/aftrekken.',
  typicalFamilies: ['GET-KOMMA-PLUS', 'GET-KOMMA-MIN']
}, {
  id: 'get.komma-tienden-vs-honderdsten',
  label: 'Verwart tienden met honderdsten',
  module: 'Getalbegrip',
  description: 'Leerling leest een verdeling in tienden alsof het honderdsten zijn (zegt 0,07 i.p.v. 0,7) of omgekeerd — de schaal van de komma-eenheid wordt fout ingeschat.',
  typicalFamilies: ['GET-KOMMA-GETALLENLIJN', 'GET-KOMMA-WAARDE']
}, {
  id: 'get.komma-schaal-genegeerd',
  label: 'Schaal van de getallenlijn genegeerd',
  module: 'Getalbegrip',
  description: 'Leerling negeert het bereik van de getallenlijn en behandelt elk streepje als één geheel (0–1 in 10 stukken wordt gelezen als 0–10).',
  typicalFamilies: ['GET-KOMMA-GETALLENLIJN']
}, {
  id: 'get.komma-delen-rest-niet-doorgeschoven',
  label: 'Rest niet doorgeschoven naar volgende decimaal',
  module: 'Getalbegrip',
  description: 'Leerling deelt eenheden en tienden los en negeert de rest van de eenheden-deling (b.v. 7,5 ÷ 3 → 7÷3 = 2,3).',
  typicalFamilies: ['GET-KOMMA-DEEL']
}, {
  id: 'get.komma-delen-komma-genegeerd',
  label: 'Komma weggelaten bij delen',
  module: 'Getalbegrip',
  description: 'Leerling laat de komma weg en deelt het getal als heel getal (b.v. 7,5 ÷ 3 → 75 ÷ 3 = 25).',
  typicalFamilies: ['GET-KOMMA-DEEL']
}, {
  id: 'get.komma-delen-aftrekken',
  label: 'Aftrekken i.p.v. delen',
  module: 'Getalbegrip',
  description: 'Leerling trekt de deler af van het getal i.p.v. te delen (b.v. 7,5 ÷ 3 → 7,5 − 3 = 4,5).',
  typicalFamilies: ['GET-KOMMA-DEEL']
}, {
  id: 'get.komma-keer-decimaal-verschoven',
  label: 'Komma één plek te ver verschoven',
  module: 'Getalbegrip',
  description: 'Leerling schuift de komma één plek te ver naar links bij het terugplaatsen (b.v. 0,3 × 4 → 0,12 i.p.v. 1,2; of 1,8 × 5 → 0,9 i.p.v. 9).',
  typicalFamilies: ['GET-KOMMA-KEER']
}, {
  id: 'get.komma-keer-genegeerd',
  label: 'Komma weggelaten bij vermenigvuldigen',
  module: 'Getalbegrip',
  description: 'Leerling rekent zonder komma en plaatst de komma niet terug (b.v. 0,3 × 4 → 12; 1,8 × 5 → 90).',
  typicalFamilies: ['GET-KOMMA-KEER']
}, {
  id: 'get.komma-keer-optellen',
  label: 'Optellen i.p.v. vermenigvuldigen',
  module: 'Getalbegrip',
  description: 'Leerling telt het kommagetal en het andere getal bij elkaar op (b.v. 0,3 × 4 → 0,3 + 0,4 = 0,7; 2,5 × 3 → 5,5).',
  typicalFamilies: ['GET-KOMMA-KEER']
}, {
  id: 'get.komma-keer-tienden-plakken',
  label: 'Eenheden en tienden naast elkaar geplakt',
  module: 'Getalbegrip',
  description: 'Leerling rekent eenheden en tienden los uit en plakt ze naast elkaar (b.v. 2,5 × 3 → 2×3=6 en 5×3=15 → 7,15 i.p.v. 7,5).',
  typicalFamilies: ['GET-KOMMA-KEER']
}, {
  id: 'get.komma-keer-extra-decimaal',
  label: 'Te veel decimalen in antwoord',
  module: 'Getalbegrip',
  description: 'Leerling telt te veel decimalen mee bij het terugplaatsen van de komma (b.v. 0,4 × 0,3 → 0,012 i.p.v. 0,12; 1,25 × 8 → 1,0 i.p.v. 10).',
  typicalFamilies: ['GET-KOMMA-KEER']
}, {
  id: 'get.komma-getallenlijn-onvoldoende-info',
  label: 'Beweert dat er onvoldoende informatie is',
  module: 'Getalbegrip',
  description: 'Leerling concludeert dat de positie op de getallenlijn niet te bepalen is, terwijl bereik en aantal stukken wél bekend zijn.',
  typicalFamilies: ['GET-KOMMA-GETALLENLIJN']
}, {
  id: 'get.komma-deel-komma-verloren',
  label: 'Komma verdwenen in antwoord bij delen',
  module: 'Getalbegrip',
  description: 'Leerling laat de komma weg in het antwoord of plaatst hem op de verkeerde positie bij delen van een kommagetal.',
  typicalFamilies: ['GET-DEEL-KOMMA', 'GET-KOMMA-DEEL']
}, {
  id: 'get.komma-deel-rest-vergeten',
  label: 'Rest niet doorgerekend bij delen',
  module: 'Getalbegrip',
  description: 'Leerling stopt voortijdig en geeft alleen het gehele deel terug als antwoord.',
  typicalFamilies: ['GET-DEEL-KOMMA', 'GET-KOMMA-DEEL']
}, {
  id: 'get.komma-deel-positiefout',
  label: 'Verkeerd cijfer op verkeerde plaats',
  module: 'Getalbegrip',
  description: 'Leerling plaatst cijfers op verkeerde plaatswaarde-posities in het quotiënt.',
  typicalFamilies: ['GET-DEEL-KOMMA', 'GET-KOMMA-DEEL']
}, {
  id: 'get.komma-cijfers-direct-vergeleken',
  label: 'Cijfers achter de komma direct vergeleken',
  module: 'Getalbegrip',
  description: 'Leerling vergelijkt de cijfers achter de komma alsof het hele getallen zijn (bv. 0,7 < 0,12 omdat 7 < 12), zonder rekening te houden met plaatswaarde.',
  typicalFamilies: ['GET-KOMMA-VERGELIJK', 'GET-VERGELIJK']
}, {
  id: 'get.komma-grootste-vs-kleinste',
  label: 'Grootste en kleinste verwisseld bij kommagetallen',
  module: 'Getalbegrip',
  description: 'Leerling geeft het kleinste kommagetal als antwoord op een vraag naar het grootste (of omgekeerd).',
  typicalFamilies: ['GET-KOMMA-VERGELIJK', 'GET-VERGELIJK']
}, {
  id: 'get.komma-weggelaten',
  label: 'Komma weggelaten in antwoord',
  module: 'Getalbegrip',
  description: 'Leerling laat de komma volledig weg in het antwoord, waardoor het getal een geheel getal wordt.',
  typicalFamilies: ['GET-KOMMA-PLUS', 'GET-KOMMA-MIN', 'GET-KOMMA-KEER', 'GET-KOMMA-DEEL']
}, {
  id: 'get.komma-getal-voor-komma-fout',
  label: 'Getal voor de komma fout',
  module: 'Getalbegrip',
  description: 'Leerling neemt een verkeerd geheel deel (voor de komma) in het antwoord, ondanks correcte cijfers achter de komma.',
  typicalFamilies: ['GET-KOMMA-PLUS', 'GET-KOMMA-MIN', 'GET-KOMMA-KEER', 'GET-KOMMA-DEEL']
}, {
  id: 'get.komma-extra-nul',
  label: 'Extra nul toegevoegd in kommagetal',
  module: 'Getalbegrip',
  description: 'Leerling voegt een onnodige nul toe in het kommagetal (bv. 2,5 → 2,05 of 2,50 als verschillende waarde gelezen).',
  typicalFamilies: ['GET-KOMMA-PLUS', 'GET-KOMMA-MIN', 'GET-KOMMA-KEER', 'GET-KOMMA-DEEL']
}, {
  id: 'get.komma-cijfers-omdraaien',
  label: 'Komma-cijfers omgedraaid',
  module: 'Getalbegrip',
  description: 'Leerling draait de cijfers voor en na de komma om bij het lezen of schrijven van een kommagetal.',
  typicalFamilies: ['GET-KOMMA-LEZEN']
}, {
  id: 'get.komma-positie-fout',
  label: 'Komma op verkeerde positie',
  module: 'Getalbegrip',
  description: 'Leerling plaatst de komma na het verkeerde cijfer bij het schrijven van een kommagetal.',
  typicalFamilies: ['GET-KOMMA-LEZEN']
}, {
  id: 'get.komma-cijfers-los-lezen',
  label: 'Komma-cijfers los gelezen',
  module: 'Getalbegrip',
  description: 'Leerling leest de cijfers achter de komma los uit (bijv. 3,14 als "drie punt één vier") in plaats van als een waarde.',
  typicalFamilies: ['GET-KOMMA-LEZEN']
}, {
  id: 'get.komma-fractie-interpretatie',
  label: 'Kommagetal als breuk geïnterpreteerd',
  module: 'Getalbegrip',
  description: 'Leerling interpreteert het deel achter de komma als een aparte breuk (bijv. 3,14 = 3 + 14/100 als losse breuk).',
  typicalFamilies: ['GET-KOMMA-LEZEN']
}, {
  id: 'get.komma-genegeerd',
  label: 'Komma genegeerd bij lezen',
  module: 'Getalbegrip',
  description: 'Leerling negeert de komma volledig en leest het getal als één geheel.',
  typicalFamilies: ['GET-KOMMA-LEZEN']
}, {
  id: 'get.komma-meer-cijfers-groter',
  label: 'Meer cijfers achter komma = groter',
  module: 'Getalbegrip',
  description: 'Leerling denkt dat een kommagetal met meer cijfers achter de komma automatisch groter is (bijv. 0,123 > 0,2).',
  typicalFamilies: ['GET-KOMMA-VERGELIJK']
}, {
  id: 'get.komma-nul-aan-eind-telt',
  label: 'Nul achter komma telt mee',
  module: 'Getalbegrip',
  description: 'Leerling denkt dat een nul aan het eind van een kommagetal de waarde verandert (bijv. 0,5 ≠ 0,50).',
  typicalFamilies: ['GET-KOMMA-VERGELIJK']
}, {
  id: 'get.komma-volgorde-verwisseld',
  label: 'Volgorde van kommagetallen verwisseld',
  module: 'Getalbegrip',
  description: 'Leerling rangschikt kommagetallen in de verkeerde volgorde (groot naar klein i.p.v. omgekeerd).',
  typicalFamilies: ['GET-KOMMA-VERGELIJK']
}];